// src/pages/legal/AffiliateTermsPage.tsx
import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

const AffiliateTermsPage: React.FC = () => (
  <LegalDocumentPage slug="affiliate-terms" fallbackTitle="Referral Agent Program Terms & Conditions" />
);

export default AffiliateTermsPage;
